webpackJsonp([231881910887020],{

/***/ 722:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"domain":"www.fileforein.com","supportEmail":"support@FileForEIN.com","title":"File For EIN","supportPhone":"888-375-8904"}}},"pathContext":{}}

/***/ })

});


// WEBPACK FOOTER //
// path---privacy-policy-4bb23511e21b4c1bac72.js